import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import "./PortfolioCard.css";

const PortfolioCard = ({ data }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const handleNavigation = (e, type, projectId) => {
		e.preventDefault();
		navigate("/portafolio/" + type.toLowerCase(), {
			state: {
				reorderItem: true,
				firstItemId: projectId,
			},
		});
	};

	const [isHoveredProject1, setIsHoveredProject1] = useState(false);
	const getImagePath = () => {
		const imageState = isHoveredProject1 ? "Hover" : "";
		const noExt = data["image"].replace(/\.webp$/, "");

		return require(`../../assets/${noExt}${imageState}.webp`);
	};
	console.log(data);

	return (
		<div
			className="card-portfolio-container"
			onClick={(e) => handleNavigation(e, data["type"], data["id"])}
		>
			<div
				className={`card-portfolio`}
				onMouseEnter={() => setIsHoveredProject1(true)}
				onMouseLeave={() => setIsHoveredProject1(false)}
			>
				<img
					src={getImagePath()}
					alt={data["alt"]}
					className="card-portfolio-image"
				/>
				<div className="card-portfolio-content">
					<div>
						<div className="card-portfolio-data">
							<h3 className="h3-bold" style={{ margin: 0 }}>
								{data["title"]}
							</h3>
						</div>
						<div className="card-portfolio-description card-portfolio-data">
							<h5 className="h5-bold" style={{ margin: 0 }}>
								{data["description"]}
							</h5>
						</div>
					</div>
					<div className="card-portfolio-bottom">
						<div className="card-portfolio-data">
							<h4 className="h4-bold" style={{ margin: 0 }}>
								{t("portfolio.projectTypeLabels." + data["type"])}
							</h4>
						</div>
						<div className="card-portfolio-button card-portfolio-data">
							<AddCircleOutlineIcon style={{ margin: "0px" }} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PortfolioCard;
